import { getContrato } from '../../../management/contract/functions';
import axios from "axios";
import { urlEmpresas, urlPessoas } from "../../../../../constants/endpoints";


export const generateIntegrationTokenEmpresa = (id) => axios.post(`${urlEmpresas}/gerarKey/${id}`)

export const validarSenha = (password) => axios.post(`${urlPessoas}/validarSenha`, { senha: password });
export const checkUserPassword = (id_pessoa, password) => axios.post(`${urlPessoas}/checkUserPassword`, { id_pessoa: id_pessoa, senha: password });
export const resetCredentials = (idEmpresa, matricula) => axios.post(`${urlPessoas}/reset`, { id_empresa: idEmpresa, matricula: matricula });


export const formatarMoeda = (valor) =>
    Number(valor ?? 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

export const formatarData = (data) => {
    if (!data) return '-';

    const [ano, mes, dia] = data.split('-');

    if (ano && mes && dia) {
        return `${dia}/${mes}/${ano}`;
    }

    return data;
};

export const getFormErrorMessage = (errors, field) => {
    if (!errors || !errors[field]) {
        return '';
    }

    return errors[field]?.message || '';
};

export const fillInputErrors = (errors, setError) => {
    if (!errors || !setError) {
        return;
    }

    Object.entries(errors).forEach(([field, message]) => {
        const errorMessage = Array.isArray(message)
            ? message[0]
            : typeof message === 'object' && message !== null
                ? message.message || Object.values(message)[0]
                : message;

        setError(field, {
            type: 'server',
            message: errorMessage || 'Valor inválido.',
        });
    });
};